function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTaskStatisticsList } from '@/api/task';
import { appletListApi } from '@/api/operation/applet';
import RightToolbar from "@/components/RightToolbar/index.vue";
import StatisticsDetail from "../components/StatisticsDetail.vue";
import { taskCodeOptions, taskTypeOptions } from '../enums';
import dayjs from 'dayjs';
export default {
  components: {
    RightToolbar: RightToolbar,
    StatisticsDetail: StatisticsDetail
  },
  data: function data() {
    return {
      todayDate: dayjs().format('YYYY-MM-DD'),
      appList: [],
      detail: {
        show: false,
        statDate: '',
        appId: '',
        taskCode: '',
        taskType: ''
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      },
      // { label: '任务编码', prop: 'taskCode', defaultValue: '', type: 'select', options: { list: taskCodeOptions } },
      {
        label: '任务类型',
        prop: 'taskType',
        defaultValue: '',
        type: 'select',
        options: {
          list: taskTypeOptions
        }
      }, {
        label: '日期',
        prop: 'createTime',
        defaultValue: [this.todayDate, this.todayDate],
        type: 'dateRange',
        options: {
          startKey: 'startDate',
          endKey: 'endDate',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'statDate',
        visible: true,
        label: "\u7EDF\u8BA1\u65E5\u671F",
        width: 160
      }, {
        key: 'application',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 120
      }, {
        key: 'taskCode',
        visible: true,
        label: "\u4EFB\u52A1\u7F16\u7801",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: taskCodeOptions
        }
      }, {
        key: 'taskType',
        visible: true,
        label: "\u4EFB\u52A1\u7C7B\u578B",
        width: 120,
        formatter: 'text',
        formatOptions: {
          list: taskTypeOptions
        }
      }, {
        key: 'participateUserCount',
        visible: true,
        label: "\u53C2\u4E0E\u4EBA\u6570",
        width: 100
      }, {
        key: 'participateCount',
        visible: true,
        label: "\u53C2\u4E0E\u6B21\u6570",
        width: 100
      }, {
        key: 'completeUserCount',
        visible: true,
        label: "\u5B8C\u6210\u4EBA\u6570",
        width: 100
      }, {
        key: 'completeCount',
        visible: true,
        label: "\u5B8C\u6210\u6B21\u6570",
        width: 100
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            value: item.id,
            label: item.appName
          });
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread({}, query), this.params);
      return getTaskStatisticsList(params).then(function (data) {
        var list = (data.list || []).map(function (item) {
          return item;
        });
        return {
          list: list,
          total: data.total
        };
      });
    },
    handleDetail: function handleDetail(row) {
      var _this2 = this;
      this.detail.statDate = row.statDate;
      this.detail.appId = row.applicationId;
      this.detail.taskType = row.taskType;
      this.detail.taskCode = row.taskCode;
      this.$nextTick(function () {
        _this2.detail.show = true;
      });
    }
  }
};